const fallbackActionId = "ACTION_WITHOUT_ID";
export {
  fallbackActionId
};
//# sourceMappingURL=constants.js.map
